import * as React from 'react';

export const Callback: React.FunctionComponent<{}> = () => (
  <div>
    <p>In callback</p>
  </div>
);
